import { updateGuestRsvp } from '@bridebook/web/app-basic/lib/rsvp/api';
import { PUBLIC_GUEST_RSVP_ROOT_QUERY_KEY } from '@bridebook/web/app-basic/lib/rsvp/hooks/use-public-guest-rsvp';
import { HttpStatusCode } from '@bridebook/toolbox/src/api/http-status';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SaveGuestRsvpRequestBody } from '@bridebook/web/pages/api/for/website/[websiteId]/rsvp/guest/save';

export const useUpdatePublicGuestRsvp = (websiteId: string) => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async (rsvpData: {
      id: SaveGuestRsvpRequestBody['id'];
      invitation: SaveGuestRsvpRequestBody['invitation'];
    }) => {
      const response = await updateGuestRsvp(websiteId, rsvpData);
      if (response.httpStatus === HttpStatusCode.OK) {
        return { response: response.data, id: rsvpData.id };
      } else {
        throw new Error('Error updating guest rsvp');
      }
    },
    onSettled: async (data) => {
      if (data && data.response.status === 'ok') {
        await queryClient.invalidateQueries([
          PUBLIC_GUEST_RSVP_ROOT_QUERY_KEY,
          'single',
          websiteId,
          { fullName: data.id },
        ]);
      }
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  };
};
